import React from "react";

const BackArrow = (props) => {
  const {handleClick} = props;
  return (
    <div className="Back-arrow" onClick={handleClick}>
      <svg
        width="113"
        height="71"
        viewBox="0 0 113 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 35.5L54.6774 0V21.3H113V49.7H54.6774V71L0 35.5Z"
          fill="#44758A"
        />
      </svg>
    </div>
  );
};

export default BackArrow;
